<mat-form-field class="mr-5" (click)="picker.open()">
  <span class="kt-menu__link-text ng-star-inserted">{{ 'RANGE_DATE.MIN' | transloco }}</span>
  <input
    matInput
    [max]="maxDateControl.value"
    [matDatepicker]="picker"
    (dateChange)="evenMinDate($event)"
    [formControl]="minDateControl"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>

<mat-form-field (click)="picker1.open()">
  <span class="kt-menu__link-text ng-star-inserted">{{ 'RANGE_DATE.MAX' | transloco }}</span>
  <input
    matInput
    [min]="minDateControl.value"
    [matDatepicker]="picker1"
    (dateChange)="eventMaxDate($event)"
    [formControl]="maxDateControl"
  />
  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
  <mat-datepicker #picker1></mat-datepicker>
</mat-form-field>
